import "./App.css";
import logo from "./logo.png";

function App() {
  return (
    <div className="flex flex-col justify-center items-center h-screen bg-[#292b2f]">
      <img src={logo} alt="RapidIQ" className="w-auto mb-4 max-h-[256px]" />
      <div className="flex flex-col rounded-lg bg-slate-50 p-5 min-w-96">
        <div className="flex flex-col place-items-center">
          <h1>RapidIQ</h1>
          <span>We are proud to announce that RapidIQ has been acquired by <a href='https://sonoransoftware.com'  className="hover:underline text-blue-500"  target="_blank" rel="noopener noreferrer">Sonoran Software</a>.</span>
          <span>It will soon be integrated into <a className="hover:underline text-blue-500" href='https://sonorancad.com' target="_blank" rel="noopener noreferrer">Sonoran CAD</a>.</span>
        </div>
      </div>
      <small className="mt-2 text-white">
        For entertainment/simulation purposes only.
        <br />
        <b>Not</b> to be used for real world medical care.
      </small>
      <small className="mt-2 text-white">
        Developed by Collin B. and Connor M.
      </small>
    </div>
  );
}

export default App;
